<template>
    <div 
      class="mt-4">
      <v-layout wrap>
        <v-flex>
          <v-dialog v-model="dialog.form"
            @keydown.esc="dialog.form = false"
            :fullscreen="dialog.fullscreen"
            width="600"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center px-4 py-2 text-right popup-header">
                <div
                  class="fs-16 font_weight_700">
                  {{ form.id === '' ? 'Tambah' : 'Ubah' }} Data Rekening
                </div>
  
                <v-spacer/>
  
                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon> -->
  
                <v-icon 
                  @click="dialog.form = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="22"
                  color="#9ca3af">
                  mdi-close
                </v-icon>
              </v-card-title>
  
              <v-divider 
                class="mt-0"
                style="border-top: 1px solid #e0e0e0;"/>
  
              <v-card-text 
                class="py-0 my-4">
                <ValidationObserver 
                  ref="form">
                  <v-form>
                    <v-row>
                      <v-col cols="12" md="12">
                        <ValidationProvider 
                          :name="`Nama Bank`" 
                          rules="required" 
                          v-slot="{ errors }">
                          <div class="fs-13 black--text">
                            Nama Bank
                            <span class="red--text fs-12">*</span>
                          </div>
                          <v-autocomplete
                            solo
                            rounded
                            dense
      
                            :color="set_color"
                            placeholder="Nama Bank"
                            v-model="form_rekening.rekening_bank_name"
                            :items="[
                              {
                                id: 'BCA',
                                name: 'BCA'
                              },
                              {
                                id: 'BRI',
                                name: 'BRI'
                              },
                              {
                                id: 'BNI',
                                name: 'BNI'
                              },
                              {
                                id: 'Mandiri',
                                name: 'Mandiri'
                              },
                              {
                                id: 'BTN',
                                name: 'BTN'
                              },
                              {
                                id: 'CIMB Niaga',
                                name: 'CIMB Niaga'
                              },
                              {
                                id: 'Bank Jateng',
                                name: 'Bank Jateng'
                              },
                              {
                                id: 'Bank Jatim',
                                name: 'Bank Jatim'
                              }
                            ]"
                            item-text="name"
                            item-value="id"
                            :error-messages="errors"
                            required
                            class="mb-0"
                            style="border-radius: 10px;">
                          </v-autocomplete>
                        </ValidationProvider>

                        <ValidationProvider 
                          :name="`Nomer Rekening`" 
                          rules="required" 
                          v-slot="{ errors }">
                          <div class="fs-13 black--text">
                            Nomer Rekening
                            <span class="red--text fs-12">*</span>
                          </div>
                          <v-text-field
                            solo
                            rounded
                            dense
                            type="number"
                            min="0"
                            :color="set_color"
                            placeholder="Nomer Rekening"
                            v-model="form_rekening.rekening_number"
                            :error-messages="errors"
                            required
                            class="mb-0"
                            style="border-radius: 10px;">
                          </v-text-field>
                        </ValidationProvider>

                        <ValidationProvider 
                          :name="`Nama Rekening`" 
                          rules="required" 
                          v-slot="{ errors }">
                          <div class="fs-13 black--text">
                            Nama Rekening
                            <span class="red--text fs-12">*</span>
                          </div>
      
                          <v-text-field
                            solo
                            rounded
                            dense
      
                            :color="set_color"
                            placeholder="Nama Rekening"
                            v-model="form_rekening.rekening_atas_nama"
                            :error-messages="errors"
                            required
                            class="mb-0"
                            style="border-radius: 10px;">
                          </v-text-field>
                        </ValidationProvider>

                        <ValidationProvider 
                          :name="`Cabang KCP/Unit`" 
                          rules="" 
                          v-slot="{ errors }">
                          <div class="fs-13 black--text">
                            Cabang KCP/Unit
                            <!-- <span class="red--text fs-12">*</span> -->
                          </div>
      
                          <v-text-field
                            solo
                            rounded
                            dense
      
                            :color="set_color"
                            placeholder="Cabang KCP/Unit"
                            v-model="form_rekening.rekening_cabang_kcp"
                            :error-messages="errors"
                            required
                            class="mb-0"
                            style="border-radius: 10px;">
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </v-form>
                </ValidationObserver>
  
              </v-card-text>
              
              <v-divider 
                class="mt-2"
                style="border-top: 1px solid #e0e0e0;"/>
              
              <v-card-actions
                class="pa-4">
                <div v-if="message.error.length > 0"
                  class="text-left mt-0">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
                <v-spacer/>
  
                <v-btn
                  @click="save()"
                  :loading="process.form"
                  :disabled="process.form"
                  width="85"
                  elevation="0"
                  :color="set_color"
                  style="border-radius: 6px;"
                  class="fs-13 font-weight-bold text-capitalize white--text">
                  Simpan
                </v-btn>
  
                <v-btn
                  @click="dialog.form = false; reset();"
                  :disabled="process.form"
                  width="85"
                  outlined
                  elevation="0"
                  color="red"
                  style="border-radius: 6px;"
                  class="fs-13 font-weight-bold text-capitalize white--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialog.delete"
            @keydown.esc="dialog.delete = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                Hapus Data Rekening

                <v-spacer/>

                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>

                <v-icon 
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/>

              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second mt-4">
                Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">Rekening</b> yang Anda pilih?
              </v-card-text>

              <div v-if="message.error.length > 0"
                class="text-center mx-6 my-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>

              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>

              <v-card-actions
                class="pa-4">
                <v-spacer/>

                <v-btn
                  rounded
                  width="120"
                  @click="deletes()"
                  :loading="process.delete"
                  :disabled="process.delete"
                  color="green"
                  elevation="0"
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Ya, Hapus
                </v-btn>

                <v-btn
                  rounded
                  width="120"
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  :disabled="process.delete"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <section>
            <v-row
              class="pa-4 pb-0 pt-0">
              <v-col
                cols="12" class="pb-1 pt-1">
                <v-card
                  flat
                  @click="$router.go(-1)"
                  style="cursor: pointer;"
                  color="#ffffff">
                  <v-card-text>
                    <div
                      class="d-flex align-center">
                      <div
                        class="d-flex align-center">
                        <v-icon
                          size="24"
                          :color="set_color">
                          mdi-backburger
                        </v-icon>
    
                        <div
                          class="fs-16 black--text ml-3"
                          style="font-weight: 600; padding-top: 1px;">
                          {{ $route.meta.title }}
                        </div>
                      </div>
    
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
  
            <v-row
              class="pa-4">
              <v-col 
                cols="12"
                class="py-0">
                <v-card 
                  flat
                  style="background-color: transparent;">
                  <v-card-text class="pa-0">
                    <v-card flat 
                      style="border-radius: 6px;">
                      <v-card-text>
                        <!-- <v-img
                          :src="form.logo_url !== undefined && form.logo_url !== '' ? form.logo_url : require('@/assets/image/image_default.png')"
                          max-height="150"
                          max-width="150"
                          class="">
                        </v-img>
                        <div class="d-flex pt-3 align-end">
                          <div class="">
                            <div class="font_weight_600 black--text fs-14">
                              {{ form.name }}
                            </div>
                            <div class="black--text fs-13 pt-1" style="font-weight: 600;">
                              {{ form.address }}, {{ form.village_name }}, {{ form.district_name }}, {{ form.city_name }}, {{ form.province_name }}
                            </div>
                          </div>
                          <div class="ml-auto text-right" style="width: 300px;">

                            <v-btn
                              :color="form.akreditasi_status === 'A' ? '#4CAF50' : form.akreditasi_status === 'B' ? '#FFC107' : form.akreditasi_status === 'C' ? '#FF5722' : '#9E9E9E'"
                              class="white--text text-capitalize"
                              elevation="0"
                              @click="openDialog"
                              style="border-radius: 4px;">
                              Akreditasi: {{ form.akreditasi_status }}
                            </v-btn>
                          </div>
                        </div>
                        <v-divider class="mt-3"></v-divider> -->
                        <v-img
                          height="300"
                          :src="form.banner_url === '' || form.banner_url === null ? require('@/assets/image/image_default.png') : form.banner_url" 
                          :alt="form.banner_url === '' || form.banner_url === null ? require('@/assets/image/image_default.png') : form.banner_url"
                          class="text-center d-flex align-center">
                          <div 
                            class="d-flex aling-center justify-center" 
                            style="width: 100%; height: auto;">
                          </div>
                        </v-img>

                        <v-row>
                          <v-col cols="12" md="12" class="pb-0">
                            <table style="border: none; width: 100%; border-collapse: collapse;">
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Nama Sekolah
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ form.name }}
                                </td>
                              </tr>
                            </table>
                          </v-col>
                          <v-col cols="12" md="6" class="pt-0">
                            <table style="border: none; width: 100%; border-collapse: collapse;">
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Kode NPSN
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ form.code }}
                                </td>
                              </tr>
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Bentuk Pendidikan
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ form.type }}
                                </td>
                              </tr>
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Status Kepemilikan
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ form.kepemilikan_status }}
                                </td>
                              </tr>
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Kurikulum
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ form.kurikulum_name === '' || form.kurikulum_name === null ? '-' : form.kurikulum_name }}
                                </td>
                              </tr>
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Jumlah Siswa
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ form.jumlah_siswa === '' || form.jumlah_siswa === null ? '-' : ( form.jumlah_siswa | number ) }} Siswa
                                </td>
                              </tr>
                              <!-- <tr v-if="form.kepemilikan_status === 'Lainnya'">
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Status Kepemilikan Lainnya
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ form.kepemilikan_status_lainnya }}
                                </td>
                              </tr> -->
                            </table>
                          </v-col>
                          <v-col cols="12" md="6" class="pt-0">
                            <table style="border: none; width: 100%; border-collapse: collapse;">
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Tanggal SK Pendirian
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ form.tgl_pengesahan | date }}
                                </td>
                              </tr>
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Status Sekolah
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ form.status }}
                                </td>
                              </tr>
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Status Akreditasi
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ form.akreditasi_status }}
                                </td>
                              </tr>
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  NPWP
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ form.npwp === '' || form.npwp === null ? '-' : form.npwp }}
                                </td>
                              </tr>
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Jumlah Pengajar
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ form.jumlah_guru === '' || form.jumlah_guru === null ? '-' : ( form.jumlah_guru | number ) }} Pengajar
                                </td>
                              </tr>
                            </table>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>

                    <v-card flat class="mt-5"
                      style="border-radius: 6px;">
                      <v-card-text>
                        <div class="fs-13 font_weight_600  black--text d-flex justify-space-between align-start" style="margin-bottom: 5px;">
                          <div>
                            Data Kontak
                          </div>
                          <div>
                            <v-btn
                              :disabled="process.form"
                              dark
                              elevation="0"
                              small
                              :color="set_color"
                              class="white--text text-capitalize"
                              style="border-radius: 6px;">
                              Tambah
                            </v-btn>
                          </div>
                        </div>
                        <div  class="mx-1">
                          <table style="border: none; width: 100%; border-collapse: collapse;">
                            <tr>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; min-width: 122px; width: 1px; white-space: nowrap;" class="black--text">
                                Email Sekolah
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;"  class="black--text">
                                No Telephone Sekolah
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                                Website Sekolah
                              </th>
                            </tr>
                            <tr>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; vertical-align: top; text-align: left; min-width: 122px; width: 1px; white-space: nowrap;" class="black--text">
                                {{ form.email === '' || form.email === null ? '-' : form.email }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; vertical-align: top; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                {{ form.phone_number === '' || form.phone_number === null ? '-' : form.phone_number }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; vertical-align: top; text-align: left; width: 100%;" class="black--text">
                                {{ form.website === '' || form.website === null ? '-' : form.website }}
                              </td>
                            </tr>
                          </table>
                        </div>
                        <!-- <table style="border: none; width: 100%; border-collapse: collapse;">
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; vertical-align: top; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                              Email Sekolah
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; vertical-align: top; text-align: left; width: 100%;"  class="black--text">
                              {{ form.email === '' || form.email === null ? '-' : form.email }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; vertical-align: top; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              No Telephone Sekolah
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; vertical-align: top; text-align: left; width: 100%;"  class="black--text">
                              {{ form.phone_number === '' || form.phone_number === null ? '-' : form.phone_number }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; vertical-align: top; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              Website Sekolah
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; vertical-align: top; text-align: left; width: 100%;"  class="black--text">
                              {{ form.website === '' || form.website === null ? '-' : form.website }}
                            </td>
                          </tr>
                        </table> -->

                        <v-divider class="my-3"></v-divider>
                        
                        <div class="fs-13 font_weight_600  black--text d-flex justify-space-between align-start" style="margin-bottom: 5px;">
                          <div>
                            Data Kepala Sekolah
                          </div>
                          <div>
                            <v-btn
                              :disabled="process.form"
                              dark
                              elevation="0"
                              small
                              :color="set_color"
                              class="white--text text-capitalize"
                              style="border-radius: 6px;">
                              Tambah
                            </v-btn>
                          </div>
                        </div>

                        <div  class="mx-1">
                          <table style="border: none; width: 100%; border-collapse: collapse;">
                            <tr>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; min-width: 122px; width: 1px; white-space: nowrap;" class="black--text">
                                Nama
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;"  class="black--text">
                                Email
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;"  class="black--text">
                                Nomor Telepon
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                                Alamat
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;"  class="black--text">
                                Tanggal Mulai Menjabat
                              </th>
                            </tr>
                            <tr>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; vertical-align: top; text-align: left; min-width: 122px; width: 1px; white-space: nowrap;" class="black--text">
                                {{ form.kepala_sekolah_name === '' || form.kepala_sekolah_name === null ? '-' : form.kepala_sekolah_name }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; vertical-align: top; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                {{ form.kepala_sekolah_email === '' || form.kepala_sekolah_email === null ? '-' : form.kepala_sekolah_email }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; vertical-align: top; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                +62 {{ form.kepala_sekolah_mobile_phone_number === '' || form.kepala_sekolah_mobile_phone_number === null ? '-' : form.kepala_sekolah_mobile_phone_number }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; vertical-align: top; text-align: left; width: 1px; white-space: nowrap; text-wrap: auto;" class="black--text">
                                {{ form.kepala_sekolah_address === '' || form.kepala_sekolah_address === null ? '-' : form.kepala_sekolah_address }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; vertical-align: top; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                {{ form.kepala_sekolah_jabatan_tmt === '' || form.kepala_sekolah_jabatan_tmt === null ? '-' : form.kepala_sekolah_jabatan_tmt | date }}
                              </td>
                            </tr>
                          </table>
                        </div>


                        <v-divider class="my-3"></v-divider>

                        <div class="fs-13 font_weight_600  black--text d-flex justify-space-between align-start" style="margin-bottom: 5px;">
                          <div>
                            Data Operator Sekolah
                          </div>
                          <div>
                            <v-btn
                              :disabled="process.form"
                              dark
                              elevation="0"
                              small
                              :color="set_color"
                              class="white--text text-capitalize"
                              style="border-radius: 6px;">
                              Tambah
                            </v-btn>
                          </div>
                        </div>
                        <div  class="mx-1">
                          <table style="border: none; width: 100%; border-collapse: collapse;">
                            <tr>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; min-width: 122px; width: 1px; white-space: nowrap;" class="black--text">
                                Nama
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;"  class="black--text">
                                Email
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;"  class="black--text">
                                Nomor Telepon
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                                Alamat
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;"  class="black--text">
                                Tanggal Mulai Menjabat
                              </th>
                            </tr>
                            <tr>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; vertical-align: top; text-align: left;min-width: 122px;  width: 1px; white-space: nowrap;" class="black--text">
                                {{ form.operator_sekolah_name === '' || form.operator_sekolah_name === null ? '-' : form.operator_sekolah_name }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; vertical-align: top; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                {{ form.operator_sekolah_email === '' || form.operator_sekolah_email === null ? '-' : form.operator_sekolah_email }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; vertical-align: top; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                +62 {{ form.operator_sekolah_mobile_phone_number === '' || form.operator_sekolah_mobile_phone_number === null ? '-' : form.operator_sekolah_mobile_phone_number }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; vertical-align: top; text-align: left; width: 1px; white-space: nowrap; text-wrap: auto;" class="black--text">
                                {{ form.operator_sekolah_address === '' || form.operator_sekolah_address === null ? '-' : form.operator_sekolah_address }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; vertical-align: top; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                {{ form.operator_sekolah_jabatan_tmt === '' || form.operator_sekolah_jabatan_tmt === null ? '-' : form.operator_sekolah_jabatan_tmt | date }}
                              </td>
                            </tr>
                          </table>
                        </div>

                        <v-divider class="my-3"></v-divider>

                        <div class="fs-13 font_weight_600  black--text d-flex justify-space-between align-start" style="margin-bottom: 5px;">
                          <div>
                            Data Pendamping Sekolah
                          </div>
                          <div>
                            <v-btn
                              :disabled="process.form"
                              dark
                              elevation="0"
                              small
                              :color="set_color"
                              class="white--text text-capitalize"
                              style="border-radius: 6px;">
                              Tambah
                            </v-btn>
                          </div>
                        </div>

                        <div  class="mx-1">
                          <table style="border: none; width: 100%; border-collapse: collapse;">
                            <tr>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                Nama
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;"  class="black--text">
                                Email
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                                Nomor Telepon
                              </th>
                            </tr>
                            <tr>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; vertical-align: top; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                {{ form.admin_name === '' || form.admin_name === null ? '-' : form.admin_name }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; vertical-align: top; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                {{ form.admin_email === '' || form.admin_email === null ? '-' : form.admin_email }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; vertical-align: top; text-align: left; width: 100%;" class="black--text">
                                +62 {{ form.admin_mobilephone === '' || form.admin_mobilephone === null ? '-' : form.admin_mobilephone }}
                              </td>
                            </tr>
                          </table>
                        </div>
                        
                        <!-- <table style="border: none; width: 100%; border-collapse: collapse;">
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              Nama Kepala Sekolah
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.kepala_sekolah_name === '' || form.kepala_sekolah_name === null ? '-' : form.kepala_sekolah_name }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              Email Kepala Sekolah
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.kepala_sekolah_email === '' || form.kepala_sekolah_email === null ? '-' : form.kepala_sekolah_email }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              Nomor Telepon Kepala Sekolah
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              +62 {{ form.kepala_sekolah_mobile_phone_number === '' || form.kepala_sekolah_mobile_phone_number === null ? '-' : form.kepala_sekolah_mobile_phone_number }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              Tanggal Mulai Menjabat Kepala Sekolah
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.kepala_sekolah_jabatan_tmt === '' || form.kepala_sekolah_jabatan_tmt === null ? '-' : form.kepala_sekolah_jabatan_tmt }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              Alamat Kepala Sekolah
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.kepala_sekolah_address === '' || form.kepala_sekolah_address === null ? '-' : form.kepala_sekolah_address }}
                            </td>
                          </tr>
                        </table>
                        <div class="fs-13 font_weight_600 mb-3 black--text">
                          Data Kontak
                        </div>
                        <table style="border: none; width: 100%; border-collapse: collapse;">
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              Nama Operator Sekolah
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.operator_sekolah_name === '' || form.operator_sekolah_name === null ? '-' : form.operator_sekolah_name }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              Email Operator Sekolah
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.operator_sekolah_email === '' || form.operator_sekolah_email === null ? '-' : form.operator_sekolah_email }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              Nomor Telepon Operator Sekolah
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                             +62  {{ form.operator_sekolah_mobile_phone_number === '' || form.operator_sekolah_mobile_phone_number === null ? '-' : form.operator_sekolah_mobile_phone_number }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              Tanggal Mulai Menjabat Operator Sekolah
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.operator_sekolah_jabatan_tmt === '' || form.operator_sekolah_jabatan_tmt === null ? '-' : form.operator_sekolah_jabatan_tmt }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              Alamat Operator Sekolah
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.operator_sekolah_address === '' || form.operator_sekolah_address === null ? '-' : form.operator_sekolah_address }}
                            </td>
                          </tr>
                        </table>
                        <table style="border: none; width: 100%; border-collapse: collapse;">
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              Nama Pendamping Sekolah
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.admin_name === '' || form.admin_name === null ? '-' : form.admin_name }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              Email Pendamping Sekolah
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.admin_email === '' || form.admin_email === null ? '-' : form.admin_email }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              Nomor Telepon Pendamping Sekolah
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              +62 {{ form.admin_mobilephone === '' || form.admin_mobilephone === null ? '-' : form.admin_mobilephone }}
                            </td>
                          </tr>
                        </table> -->
                      </v-card-text>
                    </v-card>

                    <v-card flat class="mt-5"
                      style="border-radius: 6px;">
                      <v-card-text>
                        <div class="fs-13 font_weight_600 mb-2 black--text">
                          Data Alamat
                        </div>
                        <div  class="black--text fs-13 px-1 mb-2 font_weight_600">
                          {{ form.address === '' || form.address === null ? '-' : form.address }}, RT/RW {{ form.rt_rw === '' || form.rt_rw === null ? '-' : form.rt_rw }}, Kelurahan {{ form.village_name }}, Kecamatan {{ form.subdistrict_name }}, Kota / Kabupaten {{ form.city_name }}, Provinsi {{ form.province_name }}
                        </div>
                        <!-- <table style="border: none; width: 100%; border-collapse: collapse;">
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              Alamat Sekolah
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.address === '' || form.address === null ? '-' : form.address }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              RT/RW
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.rt_rw === '' || form.rt_rw === null ? '-' : form.rt_rw }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              Kelurahan
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.village_name }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              Kecamatan
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.subdistrict_name }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              Kota / Kabupaten
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.city_name }}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              Provinsi
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.province_name }}
                            </td>
                          </tr>
                        </table> -->

                        <div
                          class="mb-6" v-if="!process.load">
      
                          <gmap-map
                            :center="center"
                            :zoom="12"
                            :options="{
                              zoomControl: true,
                              mapTypeControl: false,
                              scaleControl: false,
                              streetViewControl: false,
                              rotateControl: false,
                              fullscreenControl: true,
                              disableDefaultUi: false
                            }"
                            :clickable="false"
                            style="width: 100%; height: 300px;">
      
                            <gmap-marker
                              :position="center"
                              :draggable="false">
                            </gmap-marker>
                          </gmap-map>
                        </div>
                      </v-card-text>
                    </v-card>

                    <v-card flat class="mt-5"
                      style="border-radius: 6px;">
                      <v-card-text>
                        <div class="fs-13 font_weight_600 mb-3 black--text">
                          Data Pelengkap
                        </div>
                        <!-- <table style="border: none; width: 100%; border-collapse: collapse;">
                          <tr>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 0px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" class="black--text">
                              NPWP
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                              :
                            </td>
                            <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                              {{ form.npwp === '' || form.npwp === null ? '-' : form.npwp }}
                            </td>
                          </tr>
                        </table> -->

                        <v-card 
                          flat
                          class="mb-5">
                          <v-card-text class="px-1 py-0">
                            <div class="fs-13 black--text font_weight_600">
                              Upload Logo
                            </div>
                            <v-row>
                              <v-col class="pb-0" cols="4">
                                <v-card 
                                  flat
                                  height="200"
                                  class="d-flex align-center justify-center"
                                  style="border-radius: 15px;
                                        border: 2px solid #eaeaea; 
                                        border-style: dashed;">
            
                                  <v-img
                                    contain
                                    height="200"
                                    :src="form.logo_url === '' || form.logo_url === null ? require('@/assets/image/image_default.png') : form.logo_url" 
                                    :alt="form.logo_url === '' || form.logo_url === null ? require('@/assets/image/image_default.png') : form.logo_url"
                                    class="text-center d-flex align-center">
                                    <div 
                                      class="d-flex aling-center justify-center" 
                                      style="width: 100%; height: auto;">
                                    </div>
                                  </v-img>
                                </v-card>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
    
    
                        <v-card 
                          flat
                          class="mb-1">
                          <v-card-text class="px-1 py-0">
                            <div class="fs-13 black--text font_weight_600">
                              Upload Foto Sampul / Banner
                            </div>
                            <v-row>
                              <v-col class="pb-0" cols="12">
                                <v-card 
                                  flat
                                  height="250"
                                  class="d-flex align-center justify-center"
                                  style="border-radius: 15px;
                                        border: 2px solid #eaeaea; 
                                        border-style: dashed;">
            
                                  <v-img
                                    contain
                                    height="250"
                                    :src="form.banner_url === '' || form.banner_url === null ? require('@/assets/image/image_default.png') : form.banner_url" 
                                    :alt="form.banner_url === '' || form.banner_url === null ? require('@/assets/image/image_default.png') : form.banner_url"
                                    class="text-center d-flex align-center">
                                    <div 
                                      class="d-flex aling-center justify-center" 
                                      style="width: 100%; height: auto;">
                                    </div>
                                  </v-img>
                                </v-card>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                        <div style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text mb-4">
                          {{ form.banner_desc === '' || form.banner_desc === null ? '-' : form.banner_desc }}
                        </div>

                        <v-card 
                          flat
                          class="mb-5">
                          <v-card-text class="px-1 py-0">
                            <div class="fs-13 black--text font_weight_600">
                              Upload Foto Sekolah
                            </div>
                            <v-row>
                              <v-col class="pb-0" cols="12" md="3" v-for="(item, index) in form.galery_array" :key="index">
                                <v-img
                                  contain
                                  height="200"
                                  style="border-radius: 15px;
                                            border: 2px solid #eaeaea; 
                                            border-style: dashed;"
                                  :src="item.galery_url" 
                                  :alt="item.galery_url"
                                  class="text-center d-flex align-center">
                                  <div 
                                    class="d-flex aling-center justify-center" 
                                    style="width: 100%; height: auto;">
                                  </div>
                                  <!-- <div 
                                    @click="form.galery_array.splice(index, 1)"
                                    class="cursor-pointer"
                                    style="position: absolute; top: 5px; right: 5px;">
                                    <v-icon size="24" color="red">mdi-close-circle</v-icon>
                                  </div> -->
                                </v-img>
                              </v-col>
                            </v-row>
                            <div class="mt-5">
                              <div class="fs-13 font_weight_600  black--text d-flex justify-space-between align-start" style="margin-bottom: 5px;">
                                <div>
                                  Data Rekening
                                </div>
                                <div>
                                  <v-btn
                                    :disabled="process.form"
                                    dark
                                    @click="formRekening(); dialog.form = true"
                                    elevation="0"
                                    small
                                    :color="set_color"
                                    class="white--text text-capitalize"
                                    style="border-radius: 6px;">
                                    Tambah
                                  </v-btn>
                                </div>
                              </div>
                              <div  class="mx-1">
                                <table style="border: none; width: 100%; border-collapse: collapse;">
                                  <tr>
                                    <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: center; width: 100px; min-width: 100px; max-width: 100px;" class="black--text">
                                      Aksi
                                    </th>
                                    <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; min-width: 122px; width: 1px; white-space: nowrap;" class="black--text">
                                      Nama Bank
                                    </th>
                                    <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;"  class="black--text">
                                      Nomer Rekening
                                    </th>
                                    <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;"  class="black--text">
                                      Nama Rekening
                                    </th>
                                    <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                                      Cabang KCP/Unit
                                    </th>
                                  </tr>
                                  <tr v-for="(item, index) in form.rekening_array" :key="index">
                                    <td style="background-color: #fff; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                      <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                            @click="formRekening(index); dialog.form = true"
                                            
                                            v-bind="attrs"
                                            v-on="on"
              
                                            min-width="25"
                                            height="25"
                                            x-small
                                            rounded
                                            color="#3b3f5c"
                                            elevation="0"
                                            class="white--text text-capitalize mx-1 px-0"
                                            style="font-weight: 600; border-radius: 8px;">
                                            <v-icon size="13">mdi-pencil-outline</v-icon>
                                          </v-btn>
                                        </template>
              
                                        <span>Ubah</span>
                                      </v-tooltip>
              
                                      <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                            @click="toDelete(item.id)"
              
                                            v-bind="attrs"
                                            v-on="on"
              
                                            min-width="25"
                                            height="25"
                                            x-small
                                            rounded
                                            color="#e7515a"
                                            elevation="0"
                                            class="white--text text-capitalize mx-1 px-0"
                                            style="font-weight: 600; border-radius: 8px;">
                                            <v-icon size="13">mdi-trash-can-outline</v-icon>
                                          </v-btn>
                                        </template>
                                        
                                        <span>Hapus</span>
                                      </v-tooltip>
                                    </td>
                                    <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; min-width: 122px; width: 1px; white-space: nowrap;" class="black--text">
                                      {{ item.rekening_bank_name }}
                                    </td>
                                    <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                      {{ item.rekening_number }}
                                    </td>
                                    <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                      {{ item.rekening_atas_nama }}
                                    </td>
                                    <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                      {{ item.rekening_cabang_kcp }}
                                    </td>
                                  </tr>
                                </table>
                              </div>
                              <!-- <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;">
                                <tr>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                    Nama Bank
                                  </th>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                    Nomer Rekening
                                  </th>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                    Nama Rekening
                                  </th>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                    Cabang KCP/Unit
                                  </th>
                                </tr>
                                <tr v-for="(item, index) in form.rekening_array" :key="index">
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                    {{ item.rekening_bank_name }}
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 300px; min-width: 300px; max-width: 300px;" class="black--text">
                                    {{ item.rekening_number }}
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 250px; min-width: 250px; max-width: 250px;" class="black--text">
                                    {{ item.rekening_atas_nama }}
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                    {{ item.rekening_cabang_kcp }}
                                  </td>
                                </tr>
                              </table> -->
        
                              <v-card-text
                                v-if="form.rekening_array.length === 0"
                                class="pb-0 mb-4" style="height: 200px; display: flex; align-items: center; justify-content: center; border: 1px solid #eee; border-top: none;">
                                <div class="text-center">
                                  <div class="mt-3 fs-16">
                                    Belum ada data
                                  </div>
                                </div>
                              </v-card-text>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-card-text>
                    </v-card>
                    <div v-if="message.error.length > 0"
                      class="text-left mt-0">
                      <div
                        class="error--text d-flex align-start">
                        <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                        
                        <span
                          class="ml-1">
                          {{ message.error }}
                        </span>
                      </div>
                    </div>
                  </v-card-text>
                  <v-card-actions class="pa-5">
                    <v-spacer/>
                    <v-btn
                      :to="'/sekolah/data-sekolah/edit/' + form.id"
                      :disabled="process.form"
                      dark
                      elevation="0"
                      :color="set_color"
                      class="white--text text-capitalize"
                      style="border-radius: 6px;">
                      Ubah
                    </v-btn>
  
                    <v-btn
                      to="/sekolah/data-sekolah"
                      :disabled="process.form"
                      width="85"
                      outlined
                      elevation="0"
                      color="red"
                      style="border-radius: 6px;"
                      class="fs-13 font-weight-bold text-capitalize white--text">
                      Kembali
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { TokenService } from "@/service/Storage.Service";
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import axios from "axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          filter: {
            school_id: '',
          },
          dialog: {
            form: false,
            delete: false
          },
          step_index: 1,
          form: {
            id: '',
            name: '',
            code: '',
            status: '',
            type: '',
            kepemilikan_status: '',
            akreditasi_status: '',
            kepemilikan_status_lainnya: '',
            province_id: '',
            city_id: '',
            subdistrict_id: '',
            province_name: '',
            city_name: '',
            subdistrict_name: '',
            village_id:'',
            village_name: '',
            rt_rw: '',
            address: '',
            latitude: '',
            longitude: '',
            phone_number: '',
            email: '',
            website: '',
            tgl_pengesahan: '',
            desc: '',
            logo_url: '',
            admin_name: '',
            admin_email: '',
            admin_mobilephone: '',
            kurikulum_id: 0,
            kepala_sekolah_name: '',
            kepala_sekolah_mobile_phone_number: '',
            kepala_sekolah_address: '',
            kepala_sekolah_email: '',
            kepala_sekolah_jabatan_tmt: '',
            operator_sekolah_name: '',
            operator_sekolah_mobile_phone_number: '',
            operator_sekolah_address: '',
            operator_sekolah_email: '',
            operator_sekolah_jabatan_tmt: '',
            operator_sekolah_email: '',
            banner_url: '',
            banner_desc: '',
            galery_array: [],
            npwp: '',
            rekening_array: []
          },
          center: {
            lat: -7.703889, 
            lng: 110.60166
          },

          selected: {
            delete: []
          },
          rekening: [],

          form_rekening: {
            rekening_bank_name: '',
            rekening_number: '',
            rekening_atas_nama: '',
            rekening_cabang_kcp: '',
            school_id: '',
            id: ''
          },
          
          upload: {
            image: '',
            banner_url: null,
            galery_array: null
          },
          province: [],
          city: [],
          subdistrict: [],
          school: [],
          village: [],
          kurikulum: [],
  
          process: {
            load: true,
            image: false,
            form: false,
            banner_url: false,
            galery_array: false,
            form: false,
            delete: false
          },
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
      },
      watch: {
        'upload.image': {
          handler: function () {
            if (this.upload.image) {
              this.process.image = this.upload.image.process
  
              if (!this.process.image) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.logo_url = this.upload.image.fileuri
  
                // this.save_image()
              }
            }
          },
          deep: true
        },
        'upload.banner_url': {
          handler: function () {
            if (this.upload.banner_url) {
              this.process.banner_url = this.upload.banner_url.process
  
              if (!this.process.banner_url) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.banner_url = this.upload.banner_url.fileuri
  
                // this.save_image()
              }
            }
          },
          deep: true
        },
        'upload.galery_array': {
          handler: function () {
            if (this.upload.galery_array) {
              this.process.galery_array = this.upload.galery_array.process
  
              if (!this.process.galery_array) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.galery_array.push({
                  galery_url: this.upload.galery_array.fileuri,
                  galery_desc: ''
                })
  
                // this.save_image()
  
                this.upload.galery_array = null
              }
            }
          },
          deep: true
        },
        // 'options': {
        //   handler () {
        //     let pagination = { row: this.limit, page: 1 }
            
        //     this.fetch(pagination)
        //   },
        //   deep: true
        // }
      },
      computed: {
        token () {
          return this.$store.state.token
        },
        user () {
          this.filter.school_id = this.$store.state.user.school_id === undefined || this.$store.state.user.school_id === null ? this.$store.state.school !== undefined && this.$store.state.school !== null && this.$store.state.school !== '' ? this.$store.state.school : '' : this.$store.state.user.school_id
          return this.$store.state.user
        },
        set_color () {
          return this.$store.state.color
        }
      },
      mounted () {
        this.fetchDetail()
      },
      methods: {
        async fetchDetail() {
            this.process.load = true
           let params = {
            id: this.$route.params.id
          }
          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/school/detail' : 'school/detail'
  
          await get(`${url}`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              // this.kurikulum = res.results.data
              this.form = {
                id: res.results.data.id,
                name: res.results.data.name,
                code: res.results.data.code,
                status: res.results.data.status,
                type: res.results.data.type,
                kepemilikan_status: res.results.data.kepemilikan_status,
                akreditasi_status: res.results.data.akreditasi_status,
                kepemilikan_status_lainnya: res.results.data.kepemilikan_status_lainnya,
                province_id: res.results.data.province_id,
                province_name: res.results.data.province_name,
                city_id: res.results.data.city_id,
                city_name: res.results.data.city_name,
                subdistrict_id: res.results.data.subdistrict_id,
                subdistrict_name: res.results.data.subdistrict_name,
                village_id: res.results.data.village_id,
                village_name: res.results.data.village_name,
                rt_rw: res.results.data.rt_rw,
                address: res.results.data.address,
                latitude: res.results.data.latitude*1,
                longitude: res.results.data.longitude*1,
                phone_number: res.results.data.phone_number,
                email: res.results.data.email,
                website: res.results.data.website,
                tgl_pengesahan: res.results.data.tgl_pengesahan,
                desc: res.results.data.desc,
                logo_url: res.results.data.logo_url,
                admin_name: res.results.data.admin_pendamping.length < 1 ? '' : res.results.data.admin_pendamping[0].admin_name,
                admin_email: res.results.data.admin_pendamping.length < 1 ? '' : res.results.data.admin_pendamping[0].admin_email,
                admin_mobilephone: res.results.data.admin_pendamping.length < 1 ? '' : res.results.data.admin_pendamping[0].admin_mobilephone.replace('62', ''),
                kurikulum_id: res.results.data.kurikulum_id,
                kepala_sekolah_name: res.results.data.kepala_pegawai_name,
                kepala_sekolah_mobile_phone_number: (res.results.data.kepala_pegawai_mobile_phone_number.replace('62', '')).replace('62', ''),
                kepala_sekolah_address: res.results.data.kepala_pegawai_address,
                kepala_sekolah_email: res.results.data.kepala_pegawai_email,
                kepala_sekolah_jabatan_tmt: res.results.data.kepala_pegawai_jabatan_tmt,
                operator_sekolah_name: res.results.data.operator_pegawai_name,
                operator_sekolah_mobile_phone_number: (res.results.data.operator_pegawai_mobile_phone_number.replace('62', '')).replace('62', ''),
                operator_sekolah_address: res.results.data.operator_pegawai_address,
                operator_sekolah_email: res.results.data.operator_pegawai_email,
                operator_sekolah_jabatan_tmt: res.results.data.operator_pegawai_jabatan_tmt,
                operator_sekolah_email: res.results.data.operator_pegawai_email,
                banner_url: res.results.data.school_banner_url,
                banner_desc: res.results.data.school_banner_desc,
                galery_array: [],
                npwp: res.results.data.npwp,
                rekening_array: [],
                kurikulum_name: res.results.data.kurikulum_name
              }
  
              res.results.data.school_galery.map(item => {
                this.form.galery_array.push({
                  galery_url: item.school_galery_url,
                  galery_desc: item.school_galery_desc
                })
              })
              res.results.data.rekening.map(item => {
                this.form.rekening_array.push({
                  rekening_bank_name: item.school_rekening_bank_name,
                  rekening_number: item.school_rekening_number,
                  rekening_atas_nama: item.school_rekening_atas_nama,
                  rekening_cabang_kcp: item.school_rekening_cabang_kcp,
                  id: item.school_rekening_id
                })
              })
              this.center = {
                lat: res.results.data.latitude*1,
                lng: res.results.data.longitude*1
              }
              this.fetchRekening()
  
              this.process.load = false
            }
          })
        },
        async fetchRekening() {
  
          let params = {
            limit: 10000000000000,
            school_id: this.$route.params.id
          }
          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/rekening/data' : 'rekening/data'

          await get(`${url}`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.form.rekening_array = []
              res.results.data.map(item => {
                this.form.rekening_array.push({
                  rekening_bank_name: item.bank_name,
                  rekening_number: item.number,
                  rekening_atas_nama: item.atas_nama,
                  rekening_cabang_kcp: item.cabang_kcp,
                  id: item.id
                })
              })
            }
          })
        },
        formRekening(index) {
          if (this.$refs.form) this.$refs.form.reset()
          this.form_rekening = {
            rekening_bank_name: index !== undefined ? this.form.rekening_array[index].rekening_bank_name : '',
            rekening_number: index !== undefined ? this.form.rekening_array[index].rekening_number : '',
            rekening_atas_nama: index !== undefined ? this.form.rekening_array[index].rekening_atas_nama : '',
            rekening_cabang_kcp: index !== undefined ? this.form.rekening_array[index].rekening_cabang_kcp : '',
            school_id: this.$route.params.id,
            id: index !== undefined ? this.form.rekening_array[index].id : ''
          }
          this.process.form = false
  
          this.message.error = ''
        },

        async save () {
          this.message.error = ''

          const isValid = await this.$refs.form.validate()

          if (isValid) {
            this.process.form = true

          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? this.form_rekening.id === '' ? 'pegawai/rekening/add' : 'pegawai/rekening/update' : this.form_rekening.id === '' ? 'rekening/add' : 'rekening/update'

            // SAVE TO REST API
            await post(url, {
              data: this.form_rekening
            })
            .then(response => {
              let res = response.data
              
              this.process.form = false

              if (res.status === 200) {
                this.dialog.form = false

                this.dialog.snackbar = true
                this.message.success = res.message

                this.dialog.fullscreen = false

                this.fetchDetail()

              } else {
                this.message.error = res.message
              }
            })

          } else {
            // AUTO FOCUS ON TEXT-FIELD
            setTimeout(() => {
              const errors = Object.entries(this.$refs.form.errors)
                .map(([key, value]) => ({ key, value }))
                .filter(error => error['value'].length)
              this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }, 10)
          }
        },

        toDelete (id) {
          this.selected.delete = [id]

          this.dialog.delete = true
        },
        async deletes () {
          this.message.error = ''

          this.process.delete = true

          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/rekening/delete' : 'rekening/delete'

          await post(`${url}`, {
            data: {
              id: this.selected.delete[0],
              school_id: this.$route.params.id
            }
          }).then(response => {
            let res = response.data

            this.process.delete = false

            if (res.status === 200) {

              this.dialog.delete = false

              this.selected.row = []
              this.selected.delete = []
              
              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetchDetail()
            } else {
              this.message.error = res.message
            }
          })
        },
      },
      created () {
      }
    }
  </script>